<template>
  <SettingsPanes />
</template>
<script>
// @ is an alias to /src
import SettingsPanes from "@/components/SettingsPanes.vue";

export default {
  name: "Settings",
  components: {
    SettingsPanes,
  },
};
</script>
